module.exports = __webpack_public_path__ + "static/media/water3.6402945f.jpg";